@import "node_modules/@se/web-ui/styles/_theme.scss";
@import "../../../styles/variables.scss";

$tablet: map-get($breakpoints, tablet);

.search-tabs {
  background-color: var(--se-background, #f7f7f7) !important;
  color: var(--se-standard-contrast, #0f0f0f);
  height: 100%;
  position: relative;
  padding: 0 20px;
  font-size: 16px;

  &-nav-background {
    background-color: var(--se-background, #f7f7f7) !important;
  }
}

.nav {
  @media only screen and (max-width: 736px) {
    line-height: 1.6;
  }
}

.dropdown-menu-tab {
  font-size: 16px;
  color: #333333 !important;
  font-weight: bold;
  cursor: pointer;
  background-color: var(--se-background, #f7f7f7) !important;
  padding: 13px 25px 0;
  box-sizing: border-box;
  border: none !important;
  justify-content: center;
  align-items: center;
  border-bottom: 4px solid transparent !important;
  white-space: nowrap;
  height: 55px;
  @media (min-width: $uiaas-tablet) {
    font-size: 18px;
  }

  &:after {
    display: none !important;
  }

  display: block;
}

.dropdown-menu-tab--tabs-count {
  @extend .dropdown-menu-tab;
  height: 100%;
  padding: 20px 20px 16px 20px;
}

.dropdown-menu-button {
  display: flex;
  height: 39px;

  margin-left: -9px;
}

.loading__no-result {
  width: 100%;
  display: flex;
  align-items: center;
}

.count {
  color: #626469;
  max-height: 18px;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 4px;
  @media only screen and (min-width: 780px) {
    font-size: 16px;
  }

  &--hidden {
    opacity: 0; // In order to retain spacing
  }
}

.dropdown-menu__link {
  text-decoration: none;
  color: #333333 !important;
  display: flex;
  align-items: center;
  margin-bottom: 11px;
}

.dropdown-menu__link--tabs-count {
  @extend .dropdown-menu__link;
  align-items: unset;
  margin-top: -1px;
  margin-bottom: 0;
}

.dropdown-menu-list {
  max-height: 390px;

  @media only screen and (max-height: 650px) {
    max-height: 225px;
  }
}

.tabs {
  &__nav {
    display: flex;
    @media only screen and (max-width: 780px) {
      padding-left: 0px;
    }
    height: 100% !important;

    &-icon {
      display: flex;
      margin-right: 8px;
    }

    &-tabular {
      padding-left: 0px;
      height: 100% !important;
    }
  }

  &__header {
    @media only screen and (max-width: 780px) {
      line-height: 18px;
      justify-content: center;
      align-items: center;
    }
  }

  &__container {
    @media only screen and (max-width: 780px) {
      top: 0%;
      bottom: 0%;
      margin-bottom: 8px;
    }

    @media only screen and (min-width: 780px) {
      overflow: unset;
    }

    .tab-alternative {
      @media only screen and (max-width: 780px) {
        height: 63px !important;
        .arrow {
          text-align: center;
          width: 20px;
          padding-top: 25px !important;
        }
        .icon-nano {
          display: none;
        }
      }
      @media (min-width: 780px) {
        height: 90px !important;
      }

      .tabs {
        &__link {
          color: #333333 !important;
          font-weight: bold;
          cursor: pointer;
          background-color: #ffffff !important;
          padding: 20px 20px 16px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          border: none !important;
          border-bottom: 4px solid transparent !important;
          white-space: nowrap;
          max-width: 331px;
          line-height: 22px;
          @media (min-width: $uiaas-tablet) {
            font-size: 18px;
          }

          @media only screen and (max-width: 780px) {
            max-height: 63px !important;
            height: 63px !important;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          &:after {
            display: none !important;
          }

          &:hover {
            background-color: #e7e6e6 !important;
          }

          &.inactive {
            border-bottom-color: transparent !important;
            border-width: 4px !important;
            @media only screen and (max-width: 780px) {
              border-width: 2px !important;
            }
          }

          &.active {
            background-color: $background !important;
            border-bottom-color: var(
              --qds-theme-signature-color-default,
              #008a16
            ) !important;
            height: 100% !important;
            @media only screen and (max-width: 780px) {
              font-weight: bold;
              border-width: 2px !important;
              max-height: 63px !important;
              height: 63px !important;
            }
          }
        }
      }
    }
  }
}

.tabs__link-dropdown {
  @extend .tabs__link;
  padding: 16px 0px 16px 8px !important;
}

.tabs--rtl {
  direction: rtl;
}

nav[dir="rtl"] {
  .dropdown-menu-button {
    width: 136px;
    margin-left: 0;
  }
  .tabs__link-title-wrapper {
    padding-right: 4px;
  }
}
nav[dir="rtl"].tabs__nav {
  padding-left: 0px;
  @media (min-width: $uiaas-tablet) {
    padding-right: 16px;
  }
}
